module.exports = __webpack_public_path__ + "img/cobranding-16x9.f2af6d8d.png";